import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { MainContext } from '@blaze-cms/nextjs-components';
import { getKeysFromTemplate, compileHandlebarTemplate, buildEntityQueryFields } from '../utils';
import { getEntityData, getEntitySchema } from '../querys';
const useStringTemplate = (parent, templates, skip = false) => {
  const {
    itemEntity,
    itemId
  } = parent;
  const {
    isPreview
  } = useContext(MainContext);
  const allKeys = templates.map(template => getKeysFromTemplate(template));
  const templateKeys = [...new Set(allKeys.flat())];
  const hasTemplateKeys = !!templateKeys.length;
  const shouldSkipQuerys = skip || !hasTemplateKeys || !itemId || !itemEntity;
  const {
    loading,
    data: {
      getEntitySchema: {
        actions: {
          getPublished,
          get
        } = {}
      } = {}
    } = {}
  } = useQuery(getEntitySchema, {
    variables: {
      id: itemEntity
    },
    skip: shouldSkipQuerys
  });
  const actionToUse = isPreview ? get : getPublished || get;
  const entityQueryFields = buildEntityQueryFields(templateKeys);
  const {
    data: {
      entityData = {}
    } = {},
    loading: entityDataLoading
  } = useQuery(getEntityData(actionToUse, entityQueryFields), {
    variables: {
      id: itemId
    },
    skip: loading || shouldSkipQuerys
  });
  const isLoading = loading || entityDataLoading;
  const formatedData = {
    currentParent: _objectSpread({}, entityData)
  };
  const compiledTemplates = templates.map((template, i) => {
    const hasKeys = allKeys[i] && allKeys[i].length;
    if (!hasKeys) return template;
    return compileHandlebarTemplate(template, formatedData);
  });
  return {
    loading: isLoading,
    data: compiledTemplates
  };
};
export default useStringTemplate;
//# sourceMappingURL=use-string-template.js.map